export default "__VITE_ASSET__CBal62Mp__"